import {
    Edit,
    SimpleForm,
    TextInput,
    NumberInput,
    DateTimeInput,
    BooleanInput,
    ReferenceInput,
    SelectInput,
    FileInput,
    FileField
} from 'react-admin';
import { CountryName } from '../CountryName';
import { AdRewards } from '../AdRewards';
import { Payouts } from '../Payouts';

export const UserEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="uid" disabled fullWidth />
            <TextInput source="email" fullWidth />
            <TextInput source="display_name" fullWidth />
            <NumberInput source="age" />
            <TextInput source="phone_number" fullWidth />
            <FileInput source="photo_url" label="Photo" accept="image/*">
                <FileField source="src" title="title" />
            </FileInput>
            <DateTimeInput source="created_time" />
            <NumberInput source="token_balance" />
            <NumberInput source="rev_share_percentage" />
            <NumberInput source="balance_usd" />
            <ReferenceInput source="referred_by_user_id" reference="users" allowEmpty>
                <SelectInput optionText="email" />
            </ReferenceInput>
            <NumberInput source="lifetime_ads_watched" />
            <NumberInput source="lifetime_usd_earnings" />
            <NumberInput source="consecutive_streak_days" />
            <NumberInput source="todays_ad_count" />
            <DateTimeInput source="last_settings_refresh_date" />
            <NumberInput source="total_referred_active_users" />
            <NumberInput source="lifetime_tokens_earned" />
            <NumberInput source="redeemable_tokens" />
            <ReferenceInput source="country" reference="country_cpm_floors">
                <SelectInput optionText="country_name" />
            </ReferenceInput>
            <NumberInput source="banked_tokens_today" />
            <NumberInput source="lifetime_usd_payouts" />
            <DateTimeInput source="last_banked" />
            <NumberInput source="tokens_earned_today" />
            <BooleanInput source="dark_mode" />
            <TextInput source="paypal_email" fullWidth />
            <TextInput source="last_error_log" fullWidth />
            <BooleanInput source="referrer_redeemed" />
            <TextInput source="referrer_uid" fullWidth />
            <BooleanInput source="signup_bonus_redeemed" />
            <h3>Country</h3>
            <CountryName />
            <h3>Ad Rewards</h3>
            <AdRewards />
            <h3>Payouts</h3>
            <Payouts />
        </SimpleForm>
    </Edit>
);
